import { __assign } from "tslib";
import { alpha } from '../utils/colors';
import { defaultColors } from './colors';
import { ionColors } from './ion-colors';
import { breakpoints, generateMediaQueries } from './breakpoints';
var spacer = 1;
var spaces = {
  none: 0,
  xs: "".concat(spacer * 0.25, "rem"),
  sm: "".concat(spacer * 0.5, "rem"),
  md: "".concat(spacer, "rem"),
  lg: "".concat(spacer * 1.5, "rem"),
  xl: "".concat(spacer * 3, "rem")
};
var fontSizes = {
  0: '0.875rem',
  1: '1rem',
  2: '1.25rem',
  3: '1.5rem',
  4: '1.75rem',
  5: '2rem',
  6: '2.5rem',
  7: '3.5rem',
  8: '4.5rem',
  9: '5.5rem'
};
var ionFontSizes = {
  0: '0.625rem',
  1: '0.75rem',
  2: '0.875rem',
  3: '1rem',
  4: '1.25rem',
  5: '1.5rem',
  6: '2.125rem',
  7: '3rem',
  8: '3.75rem',
  9: '6rem'
};
var radii = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.438rem',
  xl: '3.75rem'
};
var zIndices = {
  sticky: 1020,
  fixed: 1030,
  overlay: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070
};
var sansFont = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial,' + ' "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", ' + '"Noto Color Emoji"';
var fonts = {
  sans: sansFont,
  base: sansFont,
  monospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace'
};

var ionFonts = __assign(__assign({}, fonts), {
  base: 'Grotta',
  secondary: 'Lato',
  fontFaceSource: {
    base: 'ion-fonts'
  }
});

var ionGlobalStyles = {
  globalFontSize: 16,
  styleSource: {
    base: 'ion-global-styles'
  }
};
var lineHeights = {
  heading: 1.2,
  heading2: .78,
  heading3: .62,
  heading4: .44,
  heading5: .32,
  heading6: .20,
  paragraph: .18,
  body: 1.5,
  caption: .16,
  caption2: .14
};
var ionLineHeights = {
  heading: '8.4rem',
  heading2: '6.825rem',
  heading3: '4.2rem',
  heading4: '2.975rem',
  heading5: '2.1rem',
  heading6: '1.75rem',
  body: 1.5,
  paragraph: '1.575rem',
  paragraph2: '1.4rem',
  button: '1.4rem',
  caption: '1.05rem',
  caption2: '0.875rem',
  subtitle: '1.925rem',
  subtitle2: '1.75rem',
  label: '1.225rem',
  label2: '1.05rem'
};
var fontWeights = {
  body: 400,
  heading: 500,
  display: 300
};
var ionFontWeights = {
  body: 400,
  heading: 600,
  display: 300
};
var iconSizes = {
  xs: '12px',
  sm: '16px',
  md: '1rem',
  lg: '24px',
  xl: '32px'
};
var ionContainerVariants = {
  div: 'div',
  ul: 'ul',
  head: 'head',
  span: 'span',
  section: 'section',
  article: 'article'
};
export var defaultTheme = __assign(__assign({}, defaultColors), {
  spaces: spaces,
  zIndices: zIndices,
  breakpoints: breakpoints,
  mediaQueries: generateMediaQueries(breakpoints),
  fontSizes: fontSizes,
  radii: radii,
  fonts: fonts,
  shadows: defaultColors.modes.light.shadows,
  lineHeights: lineHeights,
  fontWeights: fontWeights,
  iconSizes: iconSizes,
  outline: "3px auto ".concat(alpha(defaultColors.colors.palette.blue.base, 0.8))
});
export var ionTheme = __assign(__assign({}, ionColors), {
  spaces: spaces,
  zIndices: zIndices,
  breakpoints: breakpoints,
  mediaQueries: generateMediaQueries(breakpoints),
  globalStyles: ionGlobalStyles,
  fontSizes: ionFontSizes,
  radii: radii,
  fonts: ionFonts,
  shadows: ionColors.modes.light.shadows,
  lineHeights: ionLineHeights,
  fontWeights: ionFontWeights,
  iconSizes: iconSizes,
  containerVariants: ionContainerVariants,
  outline: "3px auto ".concat(alpha(ionColors.colors.palette.blue.base, 0.8))
});
export default defaultTheme;
export { ThemeProvider, DarkMode } from './Providers';
export { generateColorsFromScales } from './ion-colors';